import { ValidationInputType } from "@generation/core";
import { AbstractCrossFieldValidation } from "@generation/form";
import { CustomErrorMessage } from "@generation/form/src/Validations/ValidationHelper";
import { translate } from "../locales/src/translate";

export class RepeatEmailFieldValidation extends AbstractCrossFieldValidation {
  key = "isRepeatEmailFieldValidation";

  constructor(public readonly dependsOn: boolean = false, customErrorMessage?: CustomErrorMessage) {
    super(customErrorMessage);
  }

  validate = (_input: ValidationInputType): boolean => {
    const emailAdressValue = this.getValues("contactgegevens.emailAdres");
    const repeatEmailAdressValue = this.getValues("contactgegevens.emailAdresControle");
    return emailAdressValue === repeatEmailAdressValue;
  };

  defaultMessage = (label: string): string =>
    translate("RepeatEmailAdresValidationError", { label: label ?? "" });
}
